module.exports = __webpack_public_path__ + "img/enterprise_active_booking.a56b356b.svg";